import { Component, Input, OnInit } from '@angular/core';
import {
    Aangifte, AangifteBerekening,
    AangifteRapport, BokkzAlgDataService, Box1Berekening, Box3Berekening, IncomeTaxEntity,
    OpbouwBelastingBox1,
    SpecificatieBelastingBox1, Wetgeving
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, combineLatest, Subject, takeUntil } from 'rxjs';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule, DecimalPipe } from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-spec-belasting-box1',
    templateUrl: './spec-belasting-box1.component.html',
    styleUrls: ['./spec-belasting-box1.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        DecimalPipe,
        CommonModule
    ]
})
export class SpecBelastingBox1Component implements OnInit {
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;
    private partnerAangifte = {} as Aangifte;

    private destroy$ = new Subject<void>();

    specBelastingBox1FormGroup = this.fb.group<AangifteRapport>({});
    specBelastingBox1 = {} as AangifteRapport;
    aangeverRapport = {} as AangifteRapport;
    partnerRapport = {} as AangifteRapport;
    berekeningBox1 = {} as AangifteBerekening;
    aangeverBerekening = {} as AangifteBerekening;
    partnerBerekening = {} as AangifteBerekening;
    berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});
    wetgevingFg = this.fb.group<Wetgeving>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specBelastingBox1FormGroup = this.fb.group<AangifteRapport>(({
            specificatieBelastingBox1: this.fb.group<SpecificatieBelastingBox1>(({
                opbouw: this.fb.group<OpbouwBelastingBox1>(({
                    schijf1: null as unknown as number,
                    schijf2: null as unknown as number,
                    totaalSchijf1EnSchijf2: null as unknown as number,
                    schijf3: null as unknown as number,
                    schijf4: null as unknown as number,
                    tariefsaanpassingAftrekEigenWoning: null as unknown as number,
                    voorkomingVerrekenmethode: null as unknown as number,
                    voorkomingVrijstellingsmethode: null as unknown as number,
                    berekendeIB: null as unknown as number,
                    totaalIB: null as unknown as number
                } as OpbouwBelastingBox1))
            } as SpecificatieBelastingBox1))
        } as AangifteRapport));
        this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>(({
            box1: this.fb.group<Box1Berekening>(({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                inkomstenbelasting: null as unknown as number,
                inkomen1eSchijf: null as unknown as number,
                inkomen2eSchijf: null as unknown as number,
                inkomen3eSchijf: null as unknown as number,
                aftrekposten: null as unknown as number
            } as Box3Berekening))
        } as AangifteBerekening));
        this.wetgevingFg = this.fb.group<Wetgeving>({
            box1PercentageSchijf1: null as unknown as number | undefined,
            box1PercentageSchijf2: null as unknown as number | undefined,
            box1PercentageSchijf3: null as unknown as number,
            tariefsaanpassingAftrekEigenWoning: null as unknown as number,
            maxInkomen1eSchijf: null as unknown as number,
            maxInkomen2eSchijf: null as unknown as number,
            maxInkomen3eSchijf: null as unknown as number
        });
    }

    aowDatum: Date | null | undefined;

    berekenAowDatum(geboortedatum: string | Date): Date {
        const datum = new Date(geboortedatum);
        datum.setFullYear(datum.getFullYear() + 67);
        return datum;
    }

    private readonly wetgevingData = {
        2024: {
            na1945: {
                box1PercentageSchijf1: 9.32,
                box1PercentageSchijf2: 36.97,
                box1PercentageSchijf3: 49.50,
                tariefsaanpassingAftrekEigenWoning: 12.53,
                maxInkomen1eSchijf: 38098,
                maxInkomen2eSchijf: 37420,
                box2PercentageSchijf1: 24.5,
                box2PercentageSchijf2: 33,
                maxInkomen1eSchijfBox2: 66999
            },
            voor1946: {
                box1PercentageSchijf1: 8.17,
                box1PercentageSchijf2: 37.48,
                box1PercentageSchijf3: 49.50,
                tariefsaanpassingAftrekEigenWoning: 12.02,
                maxInkomen1eSchijf: 40021,
                maxInkomen2eSchijf: 35497,
                box2PercentageSchijf1: 24.5,
                box2PercentageSchijf2: 31,
                maxInkomen1eSchijfBox2: 67803
            }
        },
        2025: {
            na1945: {
                box1PercentageSchijf1: 8.17,
                box1PercentageSchijf2: 37.48,
                box1PercentageSchijf3: 49.50,
                tariefsaanpassingAftrekEigenWoning: 12.02,
                maxInkomen1eSchijf: 38441,
                maxInkomen2eSchijf: 38176,
                box2PercentageSchijf1: 24.5,
                box2PercentageSchijf2: 31,
                maxInkomen1eSchijfBox2: 67803
            },
            voor1946: {
                box1PercentageSchijf1: 8.17,
                box1PercentageSchijf2: 37.48,
                box1PercentageSchijf3: 49.50,
                tariefsaanpassingAftrekEigenWoning: 12.02,
                maxInkomen1eSchijf: 40502,
                maxInkomen2eSchijf: 36315,
                box2PercentageSchijf1: 24.5,
                box2PercentageSchijf2: 31,
                maxInkomen1eSchijfBox2: 67803
            }
        },
        2026: {
            na1945: {
                box1PercentageSchijf1: 8.10,
                box1PercentageSchijf2: 37.56,
                box1PercentageSchijf3: 49.50,
                tariefsaanpassingAftrekEigenWoning: 11.94,
                maxInkomen1eSchijf: 38883,
                maxInkomen2eSchijf: 39543,
                box2PercentageSchijf1: 24.5,
                box2PercentageSchijf2: 31,
                maxInkomen1eSchijfBox2: 68843
            },
            voor1946: {
                box1PercentageSchijf1: 8.10,
                box1PercentageSchijf2: 37.56,
                box1PercentageSchijf3: 49.50,
                tariefsaanpassingAftrekEigenWoning: 11.94,
                maxInkomen1eSchijf: 41123,
                maxInkomen2eSchijf: 37303,
                box2PercentageSchijf1: 24.5,
                box2PercentageSchijf2: 31,
                maxInkomen1eSchijfBox2: 68843
            }
        }
    };

    getWetgeving() {
        const geboortedatum = this.incomeTaxEntity.aangifte?.aangever?.geboortedatum;
        this.aowDatum = geboortedatum ? this.berekenAowDatum(geboortedatum) : null;

        const jaar = this.incomeTaxEntity.aangifte?.aangifteJaar as keyof typeof this.wetgevingData;
        const jaarData = this.wetgevingData[jaar];
        if (!jaarData) return;

        const geborenVoor1946 = geboortedatum && new Date(geboortedatum) < new Date('1946-01-01');
        this.wetgevingFg.patchValue(geborenVoor1946 ? jaarData.voor1946 : jaarData.na1945);
    }

    public ngOnInit(): void {
        combineLatest([
            this.dataService.incomeTaxEntity,
            this.dataService.aangifteBerekening,
            this.dataService.aangifteRapport,
            this.dataService.partnerAangifteRapport
        ]).pipe(takeUntil(this.destroy$)).subscribe(
            ([incomeTaxEntity, berekening, aangeverRapport, partnerRapport]) => {
                if (incomeTaxEntity) {
                    this.incomeTaxEntity = incomeTaxEntity;
                    this.getWetgeving();
                    if (berekening) {
                        this.aangeverBerekening = berekening;
                        if (berekening.partnerBerekening) {
                            this.partnerBerekening = berekening.partnerBerekening;
                        }
                    }
                    if (aangeverRapport) {
                        this.aangeverRapport = aangeverRapport;
                    }
                    if (partnerRapport) {
                        this.partnerRapport = partnerRapport;
                    }
                }
            }
        );

        this.partner.pipe(takeUntil(this.destroy$)).subscribe((partner) => {
            this.partnerBoolean = partner;
            this.specBelastingBox1FormGroup.reset();

            if (partner) {
                if (!this.partnerBerekening || !this.partnerRapport) return;
                this.berekeningBox1 = this.partnerBerekening;
                this.specBelastingBox1 = this.partnerRapport;
            } else {
                if (!this.aangeverBerekening || !this.aangeverRapport) return;
                this.berekeningBox1 = this.aangeverBerekening;
                this.specBelastingBox1 = this.aangeverRapport;
            }

            this.specBelastingBox1FormGroup.patchValue(this.specBelastingBox1);
            this.calculateBerekeningen();
            this.calculateTotaalBox1Belasting();
        });
    }

    calculateBerekeningen() {
        const maxInkomen1eSchijf = this.wetgevingFg.controls.maxInkomen1eSchijf?.value || 0;
        const maxInkomen2eSchijf = this.wetgevingFg.controls.maxInkomen2eSchijf?.value || 0;
        const belastbaarInkomenBox1 = this.berekeningBox1?.box1?.belastbaarInkomen || 0;
        if (belastbaarInkomenBox1 > (maxInkomen1eSchijf + maxInkomen2eSchijf)) {
            this.berekeningBox1FormGroup.patchValue({
                box1: {
                    inkomen1eSchijf: maxInkomen1eSchijf,
                    inkomen2eSchijf: maxInkomen2eSchijf,
                    inkomen3eSchijf: belastbaarInkomenBox1 - maxInkomen2eSchijf - maxInkomen1eSchijf
                }
            }, { emitEvent: false });
        } else if (maxInkomen1eSchijf < belastbaarInkomenBox1 && belastbaarInkomenBox1 < (maxInkomen1eSchijf + maxInkomen2eSchijf)) {
            this.berekeningBox1FormGroup.patchValue({
                box1: {
                    inkomen1eSchijf: maxInkomen1eSchijf,
                    inkomen2eSchijf: belastbaarInkomenBox1 - maxInkomen1eSchijf
                }
            }, { emitEvent: false });
        } else if (belastbaarInkomenBox1 < maxInkomen1eSchijf) {
            this.berekeningBox1FormGroup.patchValue({
                box1: {
                    inkomen1eSchijf: belastbaarInkomenBox1
                }
            }, { emitEvent: false });
        }
    }

    calculateTotaalBox1Belasting(): void {
        if (this.specBelastingBox1.specificatieInkomenBox1?.opbouw) {

            const tariefsaanpassingAftrekEigenWoningBox1 = this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.tariefsaanpassingAftrekEigenWoning || 0;
            const totaalBelastingBox1 = (this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.berekendeIB || 0) + tariefsaanpassingAftrekEigenWoningBox1;

            const schijf1 = this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.schijf1 ?? 0;
            const schijf2 = this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.schijf2 ?? 0;
            const schijf3 = this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.schijf3 ?? 0;
            const totaal1En2 = schijf1 + schijf2;

            const voorkomingVrijstellingsmethode = this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.voorkomingVrijstellingsmethode || 0;
            const voorkomingVerrekenmethode = this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.voorkomingVerrekenmethode || 0;
            let berekendeIB = this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.berekendeIB || 0;

            if (voorkomingVrijstellingsmethode && voorkomingVerrekenmethode && berekendeIB) {
                if (voorkomingVrijstellingsmethode + voorkomingVerrekenmethode >= berekendeIB) {
                    berekendeIB = 0;
                } else {
                    berekendeIB = berekendeIB - voorkomingVerrekenmethode - voorkomingVrijstellingsmethode;
                }
            }

            this.specBelastingBox1FormGroup.patchValue({
                specificatieBelastingBox1: {
                    opbouw: {
                        totaalSchijf1EnSchijf2: totaal1En2,
                        schijf3: schijf3,
                        totaalIB: totaalBelastingBox1 - voorkomingVrijstellingsmethode - voorkomingVerrekenmethode ,
                        berekendeIB: berekendeIB
                    }
                }
            }, { emitEvent: false });
        }
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }
}
